import React from "react";
import { Form, Radio } from "antd";

export const FormRadioGroup = ({
  label,
  name,
  rules,
  options = [],
  layout = "horizontal",
  size = "large",
  disabled = false,
  ...rest
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      {...rest}
      className="custom-radio-group"
    >
      <Radio.Group size={size} disabled={disabled}>
        <div
          className={`radio-options ${
            layout === "vertical" ? "flex flex-col" : "flex flex-row"
          }`}
        >
          {options?.map((option) => (
            <Radio key={option.value} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </div>
      </Radio.Group>
    </Form.Item>
  );
};
